// Modules a Standard/Custom-access-type role can be granted, not just Admin-access-type
// ones. Setting/UserRoles/Reports live here too (rather than only in adminObjectType
// below) so the "who can create/edit/archive users & roles", "who can reach Settings
// sections", and "who can view/save reports" questions are configurable per role,
// not hardcoded to the Admin access type — the seeded default roles (Operations
// Manager, Controller, Finance/Payroll Officer, HR Officer, Scheduler/Coordinator)
// are all Standard-type roles that carry real (mostly "None") values for these.
export const normalUser = {
    Branch: "Branch",
    Employee: "Employee",
    Site: "Site",
    Customer: "Customer",
    SiteGroup: "SiteGroup",
    Setting: "Setting",
    UserRoles: "UserRoles",
    Reports: "Reports",
}

// it current in use for staticField value lookups
export const objectType = {
    Agency: "Agency",
    AttendanceGap: "AttendanceGap",
    Branch: "Branch",
    Customer: "Customer",
    ComplainRegister: "ComplainRegister",
    Employee: "Employee",
    SiteGroup: "SiteGroup",
    Site: "Site",
    SiteIncident: "SiteIncident",
    Timeline: "Timeline",
    Setting: "Setting",
    UserRoles: "UserRoles",
    UserTeam: "UserTeams",
    Properties: "Properties",
    Zone: "Zone",
    Reports: "Reports",
    BusinessAnalysis: "BusinessAnalysis",
    Timesheet: "Timesheet",
    ServiceRequest: "ServiceRequest",
    // licensed modules - only offered in the role editor to tenants that have them
    Compliance: "Compliance",
    Appraisals: "Appraisals",
    Surveys: "Surveys",
    Uniform: "Uniform",

};

export const adminObjectType= [
    "Setting",
    "UserRoles",
    "UserTeams",
    "Properties"
];